import { AutogenModelCarrierRateHistory, AutogenRowCarrierRateHistory } from "./autogen/AutogenModelCarrierRateHistory";

export class ModelCarrierRateHistory extends AutogenModelCarrierRateHistory<RowCarrierRateHistory> {
    constructor() {
        super(RowCarrierRateHistory);
    }
}

export class RowCarrierRateHistory extends AutogenRowCarrierRateHistory {
}